module.exports = __webpack_public_path__ + "img/dump_parked.5e934245.svg";